import Vue from "vue";
import vailcode from "@utils/errcode";

export default {
  namespaced: true,
  state: {

  },
  mutations: {

  },
  actions: {
   
  },
  getters: {},
};
